<template>
  <div
    class="notification-item"
    :class="{ 'unread': !notification.isRead }"
    @click="handleClick"
  >
    <div class="notification-icon">
      <v-icon
        :color="getIconColor"
        size="24"
      >
        {{ getIconName }}
      </v-icon>
    </div>

    <div class="notification-body">
      <div class="notification-title-row">
        <div class="notification-title">
          {{ notification.title }}
        </div>
        <v-chip
          v-if="!notification.isRead"
          small
          color="error"
          text-color="white"
          class="new-badge"
        >
          Nueva
        </v-chip>
      </div>
      <div class="notification-message">
        {{ notification.message }}
      </div>
      <div class="notification-time">
        {{ formatTime }}
      </div>
    </div>

    <div class="notification-actions-btn">
      <v-menu
        left
        offset-x
        @click.stop
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            v-on="on"
            class="action-btn"
          >
            <v-icon small>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-tile
            v-if="!notification.isRead"
            @click="$emit('mark-read', notification.id)"
          >
            <v-list-tile-title>
              <v-icon small>done</v-icon>
              Marcar como leído
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$emit('delete', notification.id)">
            <v-list-tile-title>
              <v-icon small>delete</v-icon>
              Eliminar
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationItem',
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  computed: {
    getIconName() {
      const typeMap = {
        'success': 'check_circle',
        'error': 'error',
        'warning': 'warning',
        'info': 'info'
      }
      return typeMap[this.notification.type] || 'notifications'
    },
    getIconColor() {
      const colorMap = {
        'success': '#4caf50',
        'error': '#f44336',
        'warning': '#ff9800',
        'info': '#2196f3'
      }
      return colorMap[this.notification.type] || '#757575'
    },
    formatTime() {
      const now = new Date()
      const created = new Date(this.notification.createdAt)
      const diff = now - created

      const minutes = Math.floor(diff / 60000)
      const hours = Math.floor(diff / 3600000)
      const days = Math.floor(diff / 86400000)

      if (minutes < 1) return 'Justo ahora'
      if (minutes < 60) return `Hace ${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}`
      if (hours < 24) return `Hace ${hours} ${hours === 1 ? 'hora' : 'horas'}`
      if (days < 7) return `Hace ${days} ${days === 1 ? 'día' : 'días'}`

      return created.toLocaleDateString('es-ES', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  },
  methods: {
    handleClick() {
      if (!this.notification.isRead) {
        this.$emit('mark-read', this.notification.id)
      }
      // Redirigir a web_url si existe
      if (this.notification.webUrl) {
        this.$router.push(this.notification.webUrl)
      }
    }
  }
}
</script>

<style scoped>
.notification-item {
  padding: 16px;
  border-left: 4px solid transparent;
  border-bottom: 1px solid #eeeeee;
  transition: all 0.2s ease;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-item.unread {
  background-color: rgba(0, 43, 72, 0.04);
  border-left-color: #f44336;
}

.notification-item:hover {
  background-color: rgba(0, 43, 72, 0.08);
}

.notification-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-body {
  flex: 1;
  min-width: 0;
}

.notification-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.notification-title {
  font-weight: 600;
  font-size: 14px;
  color: #212121;
  flex: 1;
}

.notification-message {
  font-size: 13px;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notification-time {
  font-size: 12px;
  color: #9e9e9e;
}

.new-badge {
  height: 20px !important;
  font-size: 10px !important;
  padding: 0 6px !important;
  flex-shrink: 0;
}

.notification-actions-btn {
  flex-shrink: 0;
}

.action-btn {
  color: #757575;
}

.action-btn:hover {
  color: #212121;
}
</style>
